import { createDataHooks } from '@wix/premium-fed-sdk/test-utils';
export const RecommendationsDataHooks = createDataHooks('recommendations-content', 'list');
//# sourceMappingURL=dataHooks.js.map